	
	const init = inst => {
		const 	trigger = inst.querySelector( '.js-smart-basket-updating-trigger-wrap select' ),
				effected = inst.querySelector( '.js-smart-basket-updating-effected' );

		if ( trigger && effected ) {
			effected.classList.add( 'hidden-element' );

			trigger.addEventListener( 'change', e => effected.click() );
		}
	},
	instantiate = items => {
		[ ...items ].forEach( inst => init( inst ) );	
	}

	instantiate( document.querySelectorAll( '.js-smart-basket-updating' ) );
	$( document.body ).on( 'updated_cart_totals', e => instantiate( document.querySelectorAll( '.js-smart-basket-updating' ) ) );

	
